import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { Container } from '../../containers/container';
import { Tenant } from '../../entities/tenant/tenant';
import { LoadingService } from '../../services/loading.service';
import { TenantsService } from '../../services/tenants/tenants.service';
import { EditDialogService } from '../editDialog/editDialogService';
import { TenantDialogComponent } from '../tenant-dialog/tenant-dialog.component';
import * as fromGraphQl from './graphql';

interface Setting {
  key: string;
  value: any;
}

@Component({
  selector: 'app-tenant-view',
  templateUrl: './tenant-view.component.html',
  styleUrls: ['./tenant-view.component.scss']
})
export class TenantViewComponent
  extends Container<fromGraphQl.TenantQueryResponse>
  implements OnInit, OnDestroy {

  dialogRef: DynamicDialogRef | undefined;

  public tenant: Tenant;
  public id: string;
  public routeSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    loadingService: LoadingService,
    apollo: Apollo,
    public dialogService: EditDialogService,
    @Inject('env') environment : any,
    private tenantService: TenantsService
  ) {
    super(apollo, loadingService, fromGraphQl.TENANT_QUERY, environment);
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params
      .pipe(
        filter((params) => params['id'] !== undefined),
        take(1)
      )
      .subscribe((params) => {
        this.id = params['id'];
        this.subscribeToQuery({
          id: this.id,
        });
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
    super.ngOnDestroy();
  }

  handleSubscriptionResult(data: fromGraphQl.TenantQueryResponse): void {
    this.loadingService.setLoading(false);
    if (data) {
      this.queryRef.stopPolling();
      if (data.tenant) {
        this.tenant = new Tenant(data.tenant);
      }
    }
  }


  editTenant(): void {
    this.dialogRef = this.dialogService.open(TenantDialogComponent, {
      header: 'Tenant bearbeiten',
      data: this.tenant
    });
    this.dialogRef.onClose.subscribe((result) => {
      // result is true or false, indiciating if it should refetch
      if(result){
        this.queryRef.refetch();
      }
    });
  }

  switchTenant(): void {
    console.log(this);
    this.tenantService.switchTenant(this.tenant.tenantId);
  }

  getVatType(value: any): string {
    return this.tenantService.getVatTypeName(value);
  }

}
